import type { SvgIconComponent } from "@mui/icons-material";
import OpenInNewIcon from "@mui/icons-material/OpenInNewRounded";
import { Link, ListItemIcon, ListItemText, MenuItem } from "@mui/material";

interface Props {
  href: string;
  title: string;
  Icon?: SvgIconComponent;
}

const OpenExternalLinkMenuItem = ({ href, title, Icon }: Props) => {
  return (
    <MenuItem component={Link} href={href} target="_blank" rel="noopener noreferrer" sx={{ py: 1, px: 2 }}>
      {Icon && (
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
      )}
      <ListItemText>{title}</ListItemText>
      <OpenInNewIcon color="action" />
    </MenuItem>
  );
};

export default OpenExternalLinkMenuItem;
